import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { FormField } from '@shared/form-fields/models/form-field';
import { Preference } from '@shared/models/data';
import { EducationInstitutionDetail } from '@shared/models/data/EducationInstitutionDetail';
import { FieldsPrerequisite } from '@shared/models/data/fieldsPrerequisite';

@Component({
  selector: 'app-aaos-education-institution-list',
  templateUrl: './education-institution-list.component.html',
  styleUrls: ['./education-institution-list.component.scss']
})
export class EducationInstitutionListComponent implements OnInit {
  @Output() componentChanged = new EventEmitter();

  @Input() dynamicForm: FormGroup;
  @Input() field: FormField;
  @Input() fieldsPrerequisite: FieldsPrerequisite;
  @Input() applicationCountries: Preference[];

  lastId = 0;
  institutionDetails: EducationInstitutionDetail[];

  constructor() { }

  ngOnInit() {
    this.setInstitutionList();
    this.validateFormGroup();
  }

  public setInstitutionList() {
    this.institutionDetails = new Array<EducationInstitutionDetail>();
    if (this.field.value) {
      const parsedJson: Array<EducationInstitutionDetail> = JSON.parse(this.field.value);
      this.institutionDetails = parsedJson;

      const idList = this.institutionDetails.map(x => x.id);
      this.lastId = Math.max.apply(Math, idList.map(function(o) { return o; })) + 1;
    } else {
      this.addInstitution();
    }
  }

  public addInstitution() {
    const additionalInstitution = new EducationInstitutionDetail();
    additionalInstitution.id = this.lastId;
    this.lastId++;
    this.institutionDetails.push(additionalInstitution);
  }

  deleteInstitution(id: number) {
    this.institutionDetails = this.institutionDetails.filter(x => x.id !== id);
    this.onComponentChange(null);
    this.validateFormGroup();
  }

  onComponentChange(event: any) {
    if (event !== null) {
      const i = this.institutionDetails.findIndex(x => x.id === event.id);
      if (i !== -1) {
        this.institutionDetails[i].country = event.country;
        this.institutionDetails[i].name = event.name;
        this.institutionDetails[i].city = event.city;
        this.institutionDetails[i].state = event.state;
        this.institutionDetails[i].degree = event.degree;
        this.institutionDetails[i].startDate = event.startDate;
        this.institutionDetails[i].endDate = event.endDate;
      }
    }

    this.field.value = JSON.stringify(this.institutionDetails);
    this.componentChanged.emit(this.field);
  }

  validateFormGroup() {
    if (this.institutionDetails == null || this.institutionDetails.length < 1) {
      this.dynamicForm.get(this.fieldsPrerequisite.formModuleTitle).setErrors(Validators.required);
    } else {
      this.dynamicForm.get(this.fieldsPrerequisite.formModuleTitle).setErrors(null);
    }
  }
}
